type PaymentLinkApp = {
  code: string;
  name: string;
  prefix: string;
  gradient: string;
  iconText: string;
  iconBackground: string;
};

type PaymentLinkProviderConfig = {
  provider: string;
  apps: PaymentLinkApp[];
};

export type PaymentLinkAppLink = {
  code: string;
  name: string;
  href: string;
  gradient: string;
  iconText: string;
  iconBackground: string;
};

const PAYMENT_LINK_PROVIDER_CONFIGS: PaymentLinkProviderConfig[] = [
  {
    provider: 'c2c.mbank.kg',
    apps: [
      {
        code: 'bakai',
        name: 'Bakai',
        prefix: 'https://bakai.app/#',
        gradient: 'linear-gradient(135deg, #0067C7 0%, #D7193F 100%)',
        iconText: 'B',
        iconBackground: '#FFFFFF',
      },
      {
        code: 'mbank',
        name: 'MBANK',
        prefix: 'https://app.mbank.kg/qr/#',
        gradient: 'linear-gradient(135deg, #009765 0%, #F5C400 100%)',
        iconText: 'M',
        iconBackground: '#007B69',
      },
    ],
  },
  {
    provider: 'p2p.dengi.kg',
    apps: [
      {
        code: 'obank',
        name: 'O!Bank',
        prefix: 'https://api.dengi.o.kg/#',
        gradient: 'linear-gradient(135deg, #00AEEF 0%, #0050A4 100%)',
        iconText: 'O!',
        iconBackground: '#FFFFFF',
      },
      {
        code: 'demirbank',
        name: 'DemirBank',
        prefix: 'https://retail.demirbank.kg/#',
        gradient: 'linear-gradient(135deg, #0052A5 0%, #E5252A 100%)',
        iconText: 'D',
        iconBackground: '#FFFFFF',
      },
    ],
  },
];

const getPaymentLinkPayload = (paymentLink: string) => {
  try {
    return new URL(paymentLink).hash.slice(1);
  } catch {
    return paymentLink.split('#')[1] || '';
  }
};

const decodePayload = (payload: string) => {
  try {
    return decodeURIComponent(payload);
  } catch {
    return payload;
  }
};

const getPaymentLinkAppLinks = (paymentLink?: string): PaymentLinkAppLink[] => {
  if (!paymentLink) {
    return [];
  }

  const payload = getPaymentLinkPayload(paymentLink);
  if (!payload) {
    return [];
  }

  const decodedPayload = decodePayload(payload);
  const config = PAYMENT_LINK_PROVIDER_CONFIGS.find(({ provider }) =>
    decodedPayload.includes(provider),
  );

  if (!config) {
    return [];
  }

  return config.apps.map(
    ({ code, name, prefix, gradient, iconText, iconBackground }) => ({
      code,
      name,
      gradient,
      iconText,
      iconBackground,
      href: `${prefix}${payload}`,
    }),
  );
};

export const paymentLinkAppsUtils = {
  getPaymentLinkAppLinks,
};
